export default [{
  path: '/file',
  meta: {
    title: '基础资料',
    activeMenu: '/home/board'
  },
  components: {
    right: () => import('@/views/file/Index.vue')
  }
}]
